
// Load the translation dataset
const translations = {
  // ... Paste the JSON dataset here
  "subscription": "Abonnement",
  "subscription number": "Abonnement nummer",
  "one time product": "Eenmalig product",
  "days": "Dagen",
  "day": "Dag",
  "weeks": "Weken",
  "week": "Week",
  "months": "Maanden",
  "month": "Maand",
  "mon": "ma",
  "tue": "di",
  "wed": "woe",
  "thu": "do",
  "fri": "vrij",
  "sat": "zat",
  "sun": "zon",
  "jan": "jan",
  "feb": "feb",
  "mar": "mrt",
  "apr": "apr",
  "may": "mei",
  "jun": "jun",
  "jul": "jul",
  "aug": "aug",
  "sep": "sept",
  "oct": "okt",
  "nov": "nov",
  "dec": "dec"
};

// Function to translate text
function translateText(text) {
  // Check if the text to be translated exists in the source language
  if (!translations[text]) {
    console.error('Text not found in the translations.');
    return;
  }

  // Get the translation from the dataset
  const translatedText = translations[text];
  console.log(`Translated text: ${translatedText}`);
  return translatedText;
}

// Function to translate date string
function translateDate(dateString){
  let parts = dateString.split(" ");
  console.log(dateString,parts)
  parts[0] = translateText(parts[0].toLowerCase());
  parts[1] = translateText(parts[1].toLowerCase());
  return parts.join(" ");  
}
